import { Component, OnInit, OnDestroy , ViewChild, ViewContainerRef, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { menulist } from '../class/status';
import { page } from '../class/status';
import { environment } from '../../../environments/environment';
import * as moment from 'moment';
import { Dep } from '../class/auth';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as Highcharts from "highcharts";
import { chartdata } from "../class/chatdata";
import { Options } from "highcharts";
import { ActivatedRoute,Router  } from '@angular/router';

@Component({
  selector: 'app-accuse',
  templateUrl: './accuse.component.html',
  styleUrls: ['./accuse.component.css']
})

export class AccuseComponent implements OnInit, OnDestroy {

  private boundResizeHandler = () => { this.checkDeviceType(); };

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.boundResizeHandler);
  }
  @ViewChild('yourModalContent', { read: TemplateRef }) yourModalContent: TemplateRef<any>;
  Highcharts: typeof Highcharts = Highcharts;
  isDesktop: boolean; 

  search_model:string = '';
  searchcount_model:string = '';
  appearance_count:number = 0;
  search_type:string='-1';
  search_type_list:string[] = ["0"];
  status_option: menulist = [{ "id": '2', "name": "確定違規" } , { "id": '-2', "name": "已否決" } , { "id": '-1', "name": "已撤銷" }, { "id": '0', "name": "未處理" }, { "id": '1', "name": "處理中" }];
  
  accuse_template:any = [
    {name:'假冒他人資料',content:'您好，您已被檢舉「假冒他人資料」，為了避免觸及個人資料保護法第42條，因此請您2天內進行個人資料更改，並針對您的帳號進行審核，假若未更改我們將停權您的帳號；若對方提告最重處五年有期徒刑或100萬元罰金，則須自負相關法律責任，敬請您的配合。'},
    {name:'廣告、推銷',content:'您好，您已被檢舉「不當廣告、推銷」，請您留意避免涉及相關行為，若您遭多次檢舉，我們停權您的帳號；若因此而致造成相關刑責或侵權行為，請自負相關法律責任，感謝您的配合。'},
    {name:'疑似詐騙詐欺行為',content:'您好，您已被檢舉「疑似詐騙詐欺行為」，請您留意避免觸犯刑法第339條之規定，最重處五年有期徒刑或50萬元罰金，請行為人自負相關法律責任。若您遭多次檢舉，我們停權您的帳號，並自負相關法律責任。感謝您的配合。'},
    {name:'惡意騷擾、辱罵',content:'您好，您已被檢舉「惡意騷擾、辱罵」之行為，請您留意避免涉及刑法第309條之規定，公然侮辱人者，得處60日以下之拘役，嚴重者重處一年之有期徒刑。若您遭多次檢舉，我們停權您的帳號，感謝您的配合。'},
    {name:'散佈裸露色情內容',content:'您好，您已被檢舉「散佈裸露色情內容」，為了避免帳號被停權，以及涉及刑法第234條、第235條之規定，公然為猥褻行為或故意散布猥褻物者，最重處兩年有期徒刑，須請您於2天內刪除相關裸露內容，且須自負相關法律責任，感謝您的配合！'},

  ];
  updateFlag:boolean=false;
  pieOptions: any =  JSON.parse(JSON.stringify(chartdata.pie));
  pieOptions2: any = JSON.parse(JSON.stringify(chartdata.pie));
  link:string = environment.link;
  edit_data:any=[];
  data:any=[];
  accname:string = '';
  accusedata:any=[];
  allstatus:boolean=false;
  loading:boolean=false;
  pageobj:page = {page:0,count:10,total_count:0};
  pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj));
  pageobj2:page = {page:0,count:10,total_count:0};
  pageobjstr2:string=JSON.parse(JSON.stringify(this.pageobj2));
  pageobj3:page = {page:0,count:10,total_count:0};
  pageobjstr3:string=JSON.parse(JSON.stringify(this.pageobj3));
  time :any={};
  time2 :any={};
  timeset = [{ type:1 , name: "今天", num: -0 },{ type:3 , name: "昨天", num: -1 },{ type:1 , name: "過去7天", num: -7 },{ type:1 , name: "過去30天", num: -30 }, ,{ type:2 , name: "上個月", num: -1 }, { type:2 , name: "上上個月", num: -2 }];
  urltoken:string = '';
  preurl:string = '';
  menu_list:menulist = [
    {id:'0',name:'檢舉列表'},
    {id:'1',name:'檢舉次數'},
  ];
  now:string = '0';
  sort_obj:any = {column:'appearance_count',sort:'0'}
  gender_list:menulist = [{id:'1',name:'男生'},{id:'2',name:'女生'}]
  v_list:any=[];

  tool_obj = {gender:'1',vid:'-1'};

  //table compoment
  title = [{title:'名稱'},{title:'次數',sort:'appearance_count',css:'min-width: 80px;'}];

  //title = data的key值  type: 1:圖片compoment 2.會員compoment
  content = [{title:'name',type:2},{title:'appearance_count',format:'number',model:1}];    

  //table compoment
  modeltitle = [{title:'投訴者'},{title:'投訴原因'},{title:'投訴佐證圖片'},{title:'通知被檢舉者訊息'},{title:'最後操作人'},{title:'投訴時間'}];  
  //title = data的key值  type: 1:圖片compoment 2.會員compoment
  modelcontent = [{title:'from_name'},{title:'reasons'},{title:'pic',type:1},{title:'notice_text'},{title:'emp_name'},{title:'create_dt'}]; 

  routeUid = '';

  searchaccuse = false;

  reason = '-2';

  reason_list:menulist = [];
  
  handleClick( value: any ): void {
    this.accuse_detail(value);
    this.modalService.open(this.yourModalContent, { centered: true,size: 'lg' });
  }


  accuse_detail(name){
    this.accname = name;
    const body = {page: this.pageobj3.page,count:this.pageobj3.count,time:this.time2,now:2,
        search:name,  
        search_type:['2'],  
    };
    this.loading = true;
    this.httpClient.post<any>("/customer_service/get_accuselist.php",body).subscribe(res => {
      this.loading = false;
      if(res.status){
        this.accusedata = res.data;
        this.pageobj3.total_count = res.total_count
      }else{
        this.pageobj3.total_count = 0
        this.accusedata = [];
      }
      this.pageobjstr3=JSON.parse(JSON.stringify(this.pageobj3));
      console.log('res',res);
    });
  }

  handlesortdata( value: any ): void {
    this.sort_obj = value;
    this.user_count();
  }

  constructor(
    public httpClient: HttpClient,
    private modalService: NgbModal,
    private viewContainerRef: ViewContainerRef,
    private  route: ActivatedRoute,
    ) { }
  ngOnInit(): void {

    if (this.route.snapshot.paramMap.get('uid')) {
        this.routeUid = this.route.snapshot.paramMap.get('uid');
        this.search_model = this.routeUid;
        this.searchaccuse = true;
        this.allstatus = true;
        this.search_type_list = ["-2","-1","0","1","2"];
    }

    this.init_list();
    this.preurl = environment.serverurl;
    this.urltoken = this.preurl+"/export_excel.php?limit=true&token="+Dep.token+"&time="+Date.now()+'&type=0'; 
    this.checkDeviceType();
    window.addEventListener('resize', this.boundResizeHandler);
  }

  handleRangeSelectedacc( value: any ): void {

    let  eventDate = value.event;

    this.time2.startDate =  '';
    this.time2.endDate =  '';

    if(eventDate.startDate){
        this.time2.startDate =  moment(eventDate.startDate).format('YYYY-MM-DD')
        this.time2.endDate =  moment(eventDate.endDate).format('YYYY-MM-DD')    
    }

    this.user_count();
  }


  handleRangeSelected( value: any ): void {
    let  eventDate = value.event;

    this.time.startDate =  '';
    this.time.endDate =  '';

    if(eventDate.startDate){
        this.time.startDate =  moment(eventDate.startDate).format('YYYY-MM-DD')
        this.time.endDate =  moment(eventDate.endDate).format('YYYY-MM-DD')    
    }

    this.init_list();
  }

  init_list(){
    this.urltoken = this.preurl+"/export_excel.php?limit=true&token="+Dep.token+"&time="+Date.now()+'&type=0'; 
    const body = {page: this.pageobj.page,count:this.pageobj.count,time:this.time,now:0,
    search:this.search_model,  
    search_type:this.search_type_list,  
    searchaccuse:this.searchaccuse,
    searchreason:this.reason,
    };
    this.loading = true;
    this.httpClient.post<any>("/customer_service/get_accuselist.php", body).subscribe(res => {
      this.loading = false;
      if(res.status){
        this.data = res.data.map(item => { 
          return {
              ...item, // 保留原本的所有屬性
              furl: item.report_item_id === '1' 
                  ? `/admin_rtc/user/${item.to_uid};act=1` 
                  : item.furl // 保留原本的 URL
          };
        });
        this.pageobj.total_count = res.total_count;
      }else{
        this.pageobj.total_count = 0
        this.data = [];
      }
      this.reason_list = res.select;
      this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj));
      this.now = '0';
      console.log('res',res);
    });
  }

  all(){
    if(this.allstatus){
      this.search_type_list = ["-2","-1","0","1","2"];
    }else{
      this.search_type_list = [];
    }
    this.init_list();
  }
  save() {
    if (this.edit_data.result == -1) {
        alert('請選擇處理動作');
        return;
    }

    if (this.edit_data.result == 1 && this.edit_data.accresult == null) {
        alert('請選擇是否停權動作');
        return;
    }

    if(this.edit_data.result == 0){
        this.edit_data.accresult == null;
    }

    document.getElementById("close").click();
    const body = { data: this.edit_data };
    this.loading = true;

    this.httpClient.post<any>("/update_accuse.php", body).subscribe(res => {
        this.loading = false;
        if (res.status) {
            this.init_list();
        }
        console.log('save', res);
    });
  }

  check_it(value:string){
    return this.search_type_list.indexOf(value)!=-1;
  }
  
  choosetag(id){
    if(id=='1'){
        this.now = id;
        this.user_count();
    }else{
        this.init_list();
    }
  }

  user_count(){
    const body = {page: this.pageobj2.page,count:this.pageobj2.count,now:this.now,sort_obj:this.sort_obj,time:this.time2,gender:this.tool_obj.gender,vid:this.tool_obj.vid,search:this.searchcount_model};
    this.loading = true;
    this.httpClient.post<any>("/customer_service/get_accuselist.php",body).subscribe(res => {
        this.loading = false;
        if(res.status){
          this.data = res.data;
          this.v_list = res.vlist;
          this.pageobj2.total_count = res.total_count
        }else{
          this.pageobj2.total_count = 0
          this.v_list = [];
          this.data = [];
          this.tool_obj.vid = '-1';
        }
        this.pageobjstr2=JSON.parse(JSON.stringify(this.pageobj2));
   

        if(typeof(res.appearance_count)!='undefined'){
          this.appearance_count = res.appearance_count;
        }else{
          this.appearance_count = 0;
        }
        
        const series = [
            {
              name: "百分比",
              colorByPoint:true,
              data:res.pie_chat.accuse_data.data,
            }
        ];
          
        
         
        const series2 = [
            {
              name: "百分比",
              colorByPoint:true,
              data:res.pie_chat.vendor_data.data,
            }
        ];
          
        
        this.pieOptions.series = series;
        this.pieOptions2.series = series2;

        this.pieOptions.title.text = res.pie_chat.accuse_data.name;
        this.pieOptions2.title.text = res.pie_chat.vendor_data.name;

        this.updateFlag = true;

    });
  }



  choose(value:string){
    const index = this.search_type_list.findIndex((v)=>{
      return v == value;
    })
    if(index!=-1){
      this.search_type_list.splice(index,1);
    }else{
      this.search_type_list.push(value);
    }

    if(this.search_type_list.length==5){
      this.allstatus = true;
      this.all();
    }else{
      this.allstatus = false;
    }

    this.search_type_list.sort();
    this.init_list();
  }

  callback(pageobj:page){
    if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
      this.pageobj = pageobj;
      this.init_list();
    }
  }

  callback2(pageobj:page){
    if(JSON.stringify(this.pageobj2)!=JSON.stringify(pageobj)){
      this.pageobj2 = pageobj;
      this.user_count();
    }
  }

  callback3(pageobj:page){
    if(JSON.stringify(this.pageobj3)!=JSON.stringify(pageobj)){
      this.pageobj3 = pageobj;
      this.accuse_detail(this.accname);
    }
  }
  checkDeviceType() {
    if (window.innerWidth > 768) { // 假設768px是切換點
        this.isDesktop = true;
    } else {
        this.isDesktop = false;
    }
  }
  
}
